import createSubmit from '../../Form/createSubmitButton.jsx'
import { name } from './MySearchExtraForm.jsx'

export default createSubmit(name)